/* RESPONSIBLE TEAM: team-phone */
import PhoneHoldAndAssignSerializer from '../step';

export default PhoneHoldAndAssignSerializer;
